import * as React from "react";
import BirthTimeSelector from "./BirthTimeSelector";
import PensionCalculationResult from "./PensionCalculationResult";

interface IPensionAgeCalculatorProps {
    firstBirthYearWithData: number;
    lastBirthYearWithData: number;
    sourceFileId: string;
    estimationStartFrom: number;
    estimationsLabel: string;
    yearInputPlaceholder: string;
    monthInputLabel: string;
    yearsLabel: string;
    monthsLabel: string;
    lowestAgeLabel: string;
    targetAgeLabel: string;
    latestAgeLabel: string;
    dateLabel: string;
}

interface IPensionAgeCalculatorState {
    selectedBirthYear: number;
    selectedBirthMonth: number;
}

export default class PensionAgeCalculator extends React.Component<
    IPensionAgeCalculatorProps,
    IPensionAgeCalculatorState
> {
    constructor(props: IPensionAgeCalculatorProps) {
        super(props);
        this.state = {
            selectedBirthMonth: 1,
            selectedBirthYear: this.props.estimationStartFrom,
        };

        this.onBirthYearSelection = this.onBirthYearSelection.bind(this);
        this.onBirthMonthSelection = this.onBirthMonthSelection.bind(this);
    }

    public render() {
        return (
            <div>
                    <BirthTimeSelector
                        minValue={this.props.firstBirthYearWithData}
                        maxValue={this.props.lastBirthYearWithData}
                        yearInputPlaceholder={this.props.yearInputPlaceholder}
                        monthInputLabel={this.props.monthInputLabel}
                        selectedYear={this.state.selectedBirthYear}
                        selectedMonth={this.state.selectedBirthMonth}
                        onBirthYearSelection={this.onBirthYearSelection}
                        onBirthMonthSelection={this.onBirthMonthSelection}
                    />

                    {/* tslint:disable-next-line:jsx-no-multiline-js */}
                    {this.state.selectedBirthYear >= this.props.firstBirthYearWithData && (
                        <PensionCalculationResult
                            birthMonth={this.state.selectedBirthMonth}
                            birthYear={this.state.selectedBirthYear}
                            sourceFileId={this.props.sourceFileId}
                            estimationsStart={this.props.estimationStartFrom}
                            estimationsLabel={this.props.estimationsLabel}
                            monthsLabel={this.props.monthsLabel}
                            yearsLabel={this.props.yearsLabel}
                            lowestAgeLabel={this.props.lowestAgeLabel}
                            targetAgeLabel={this.props.targetAgeLabel}
                            latestAgeLabel={this.props.latestAgeLabel}
                            dateLabel={this.props.dateLabel}
                        />
                    )}
            </div>
        );
    }

    private onBirthYearSelection(event: React.ChangeEvent<HTMLInputElement>) {
        try {
            const newBirthYear = Number(event.target.value);
            this.setState({ ...this.state, selectedBirthYear: newBirthYear });
        } catch (e) {
            // We should not end up here, because slider should only give valid values
            console.error(e);
        }
    }

    private onBirthMonthSelection(event: React.ChangeEvent<HTMLSelectElement>) {
        try {
            const newBirthMonth = Number(event.target.value);
            this.setState({ ...this.state, selectedBirthMonth: newBirthMonth });
        } catch (e) {
            console.error(e);
        }
    }
}

export interface IPensionCalculationResultProps {
    birthYear: number;
    birthMonth: number;
    sourceFileId: string;
    estimationsStart: number;
    estimationsLabel: string;
    yearsLabel: string;
    monthsLabel: string;
    lowestAgeLabel: string;
    targetAgeLabel: string;
    latestAgeLabel: string;
    dateLabel: string;
}
